import { connect } from 'react-redux'
import Admin from '../../components/admin/admin.component'
import {
  changeAdminMenu,
  expandAdminInvoice,
  hideAdminSnackbar,
  expandAdminUser,
  irSearchPageChange,
  searchAdminInvoice,
  searchAdminWages,
  userSearchPageChange,
  adminDeleteCompanyUpdates,
  tiedotteetSearchPageChange,
  warnInvoiceToPay,
  warnSalaryToPay,
  confirmSalaryToPay,
  importKassavirtanenSalaries,
  salarySendtoIR,
  cancelSalaryIRReport,
  manualPaySalaries,
  noPikapalkka,
  showSalaryPDF,
  showInvoicePDF,
  showReminderInvoicePDF,
  updateAdminInvoiceStatus,
  cancelUpdateAdminInvoiceStatus,
  closeDialog,
  updateAdminSalaryStatus,
  cancelUpdateAdminSalaryStatus,
  adminGetUpdates,
  updateAdminInvoiceStatusToRejected,
  updateAdminInvoiceStatusToNew,
  updateAdminInvoiceStatusToLoaned,
  sentInvoiceReminder,
  updateAdminInvoiceStatusToPerinnassa,
  updateSalaryStatusIR,
  updateAdminTableSuccess,
  getFieldOfWork,
  expandAdminSalary,
  removeInvoiceFeeWithReason,
  cancelRemoveInvoiceFeeDialog,
  getUserCompanyUpdateInfo,
  searchCompanyCustomers
} from '../../actions/index'

let AdminContainer = Admin

const mapStateToProps = (state) => {
  const fieldOfWork = state.admin.fieldOfWork ? state.admin.fieldOfWork : []

  return {
    fieldOfWork: fieldOfWork,
    isSalaryRowSelected: state.admin.isSalaryRowSelected,
    selectedRows: state.admin.selectedRows,
    selected: state.admin.selected,
    isToPay: state.admin.isToPay,
    isToLiftSalary: state.admin.isToLiftSalary,
    isImportSalary: state.admin.isImportSalary,
    isValidBatch: state.admin.isValidBatch,
    isIRValidBatch: state.admin.isIRValidBatch,
    isIRCacelReportValidBatch: state.admin.isIRCacelReportValidBatch,
    isToPayInvoiceId: state.admin.isToPayInvoiceId,
    isInvoiceUnclear: state.admin.isInvoiceUnclear,
    isLahetetty: state.admin.isLahetetty,
    isReklamoitu: state.admin.isReklamoitu,
    isPerinnassa: state.admin.isPerinnassa,
    isToPaySalaryId: state.admin.isToPaySalaryId,
    invoiceSearchRows: state.admin.invoiceSearchRows,
    searchInvoiceSummary: state.admin.searchInvoiceSummary,
    userSearchRows: state.admin.userSearchRows,
    salarySearchRows: state.admin.salarySearchRows,
    salarySearchSummary: state.admin.salarySearchSummary,
    releaseSearchRows: state.admin.releaseSearchRows,
    irSearchRows: state.admin.irSearchRows,
    showSpinner: state.admin.showSpinner,
    showAdminSnackbar: state.admin.showAdminSnackbar,
    showAdminFailSnackbar: state.admin.showAdminFailSnackbar,
    isUpdateTaxCardSuccess: state.admin.isUpdateTaxCardSuccess,
    isUpdateTaxCardFailed: state.admin.isUpdateTaxCardFailed,
    showAdminSalPayFailSnackbar: state.admin.showAdminSalPayFailSnackbar,
    salPayFailMessage: state.admin.salPayFailMessage,
    showAdminSalaryStatusSuccessSnackbar:
      state.admin.showAdminSalaryStatusSuccessSnackbar,
    salaryStatusSuccessMessage: state.admin.salaryStatusSuccessMessage,
    showExpenseReportSuccessSnackbar:
      state.admin.showExpenseReportSuccessSnackbar,
    showExpenseReportFailedSnackbar:
      state.admin.showExpenseReportFailedSnackbar,
    expenseReportFailedMessage: state.admin.expenseReportFailedMessage,
    invoiceSearchPages: Math.ceil(
      state.admin.totalInvoiceCount / state.admin.adminInvoicePageSize
    ),
    userSearchPages: !!state.admin.userSearchRows
      ? Math.ceil(state.admin.userSearchRows.length / 10)
      : 0,
    salarySearchPages: Math.ceil(
      state.admin.totalSalariesCount / state.admin.adminSalaryPageSize
    ),
    tiedotteetSearchPages: !!state.admin.releaseSearchRows
      ? Math.ceil(state.admin.releaseSearchRows.length / 10)
      : 0,
    iRSearchPages: !!state.admin.irSearchRows
      ? Math.ceil(state.admin.irSearchRows.length / 10)
      : 0,
    adminSalaryPageSize: state.admin.adminSalaryPageSize,
    selectedSalaryRowIndex: state.admin.selectedSalaryRowIndex,
    adminInvoicePageSize: state.admin.adminInvoicePageSize,
    shouldCloseUserForms: state.admin.shouldCloseUserForms,
    shouldCloseInvoiceForms: state.admin.shouldCloseInvoiceForms,
    shouldUpdateTable: state.admin.shouldUpdateTable,
    isMuokattu: state.admin.isMuokattu,
    isAdminSent: state.admin.isAdminSent,
    shouldUpdateTable: state.admin.shouldUpdateTable,
    allInvoiceInMonthSearch: state.admin.allInvoiceInMonthSearch,
    isAdminRejected: state.admin.isAdminRejected,
    showPartialPayFailSnackbar: state.admin.showPartialPayFailSnackbar,
    partialPayFailMessage: state.admin.partialPayFailMessage,
    showPartialPDFSuccessSnackbar: state.admin.showPartialPDFSuccessSnackbar,
    partialPayPDFSuccessMessage: state.admin.partialPayPDFSuccessMessage,
    allInvoiceInMonthSearch: state.admin.allInvoiceInMonthSearch,
    allSalaryRecords: state.admin.allSalaryRecords,
    isAdminHalfPaid: state.admin.isAdminHalfPaid,
    showSsnSnackbar: state.admin.showSsnSnackbar,
    shouldCloseSalaryForms: state.admin.shouldCloseSalaryForms,
    isReminderActive: state.admin.isReminderActive,
    showRemoveInvoiceFeeDialog: state.admin.showRemoveInvoiceFeeDialog,
    feeType: state.admin.feeType,
    invoiceNotes: state.admin.invoiceNotes,
    is_group_invoice: state.admin.is_group_invoice
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeAdminMenu: (value, email) => dispatch(changeAdminMenu(value, email)),
    expandAdminInvoice: (expanded, invoice_id, partial_invoice_id, uuid) =>
      dispatch(
        expandAdminInvoice(expanded, invoice_id, partial_invoice_id, uuid)
      ),
    hideAdminSnackbar: () => dispatch(hideAdminSnackbar()),
    expandAdminUser: (expanded, uuid) =>
      dispatch(expandAdminUser(expanded, uuid)),
    irSearchPageChange: (selected) => dispatch(irSearchPageChange(selected)),
    searchAdminInvoice: (selectedPage, refreshSearch, formValues) =>
      dispatch(searchAdminInvoice(selectedPage, refreshSearch, formValues)),
    searchAdminWages: (selectedPage, refreshSearch, formValues) =>
      dispatch(searchAdminWages(selectedPage, refreshSearch, formValues)),
    userSearchPageChange: (selected) =>
      dispatch(userSearchPageChange(selected)),
    tiedotteetSearchPageChange: (selected) =>
      dispatch(tiedotteetSearchPageChange(selected)),
    warnInvoiceToPay: (selected) => dispatch(warnInvoiceToPay(selected)),
    warnSalaryToPay: (selected) => dispatch(warnSalaryToPay(selected)),
    confirmSalaryToPay: () => dispatch(confirmSalaryToPay()),
    importKassavirtanenSalaries: (selected) =>
      dispatch(importKassavirtanenSalaries(selected)),
    salarySendtoIR: (selected) => dispatch(salarySendtoIR(selected)),
    updateSalaryStatusIR: (selected) =>
      dispatch(updateSalaryStatusIR(selected)),
    cancelSalaryIRReport: (selected) =>
      dispatch(cancelSalaryIRReport(selected)),
    manualPaySalaries: (selected) => dispatch(manualPaySalaries(selected)),
    noPikapalkka: (payload) => dispatch(noPikapalkka(payload)),
    showSalaryPDF: (salary_id, uuid, invoice_uuid) => dispatch(showSalaryPDF(salary_id, uuid, invoice_uuid)),
    showInvoicePDF: (invoice_id) => dispatch(showInvoicePDF(invoice_id)),
    showReminderInvoicePDF: (invoice_id) =>
      dispatch(showReminderInvoicePDF(invoice_id)),
    updateAdminInvoiceStatus: (invoice_id) =>
      dispatch(updateAdminInvoiceStatus(invoice_id)),
    cancelUpdateAdminInvoiceStatus: () =>
      dispatch(cancelUpdateAdminInvoiceStatus()),
    closeDialog: () => dispatch(closeDialog()),
    updateAdminSalaryStatus: (id) => dispatch(updateAdminSalaryStatus(id)),
    cancelUpdateAdminSalaryStatus: (id) =>
      dispatch(cancelUpdateAdminSalaryStatus(id)),
    adminDeleteCompanyUpdates: (id) => dispatch(adminDeleteCompanyUpdates(id)),
    adminGetUpdates: () => dispatch(adminGetUpdates()),
    updateAdminInvoiceStatusToRejected: () =>
      dispatch(updateAdminInvoiceStatusToRejected()),
    updateAdminInvoiceStatusToLoaned: () =>
      dispatch(updateAdminInvoiceStatusToLoaned()),
    sentInvoiceReminder: (invoice_id) =>
      dispatch(sentInvoiceReminder(invoice_id)),
    updateAdminInvoiceStatusToPerinnassa: (invoice_id) =>
      dispatch(updateAdminInvoiceStatusToPerinnassa(invoice_id)),
    updateAdminTableSuccess: () => dispatch(updateAdminTableSuccess()),
    getFieldOfWork: () => dispatch(getFieldOfWork()),
    updateAdminInvoiceStatusToNew: (status, notes) =>
      dispatch(updateAdminInvoiceStatusToNew(status, notes)),
    expandAdminSalary: (expanded, id, uuid, index) =>
      dispatch(expandAdminSalary(expanded, id, uuid, index)),
    removeInvoiceFeeWithReason: (feeType) =>
      dispatch(removeInvoiceFeeWithReason(feeType)),
    cancelRemoveInvoiceFeeDialog: () =>
      dispatch(cancelRemoveInvoiceFeeDialog()),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo()),
    searchCompanyCustomers: (email) => dispatch(searchCompanyCustomers(email))
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

AdminContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AdminContainer)

export default AdminContainer
